// Fonction robuste pour parser une date ISO sans décalage de fuseau horaire
function parseISODate(dateStr) {
  if (!dateStr) {
    return null;
  }
  if (dateStr instanceof Date) {
    return dateStr;
  }
  if (typeof dateStr === 'string') {
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      const [year, month, day] = parts.map(Number);
      if (!isNaN(year) && !isNaN(month) && !isNaN(day) && year > 1000) {
        const date = new Date(year, month - 1, day);
        date.setHours(0, 0, 0, 0);
        return date;
      }
    }
  }
  // Si le format est invalide, on ne lève plus d'erreur pour éviter un crash.
  // On affiche un avertissement pour le débogage et on retourne null.
  console.warn('parseISODate a reçu une donnée invalide et l\'a ignorée:', dateStr);
  return null;
}

// Fonction robuste pour obtenir le lundi de la semaine d'une date
function getMonday(date) {
  const d = new Date(date);
  const day = d.getDay();
  // Si c'est dimanche (0), on recule de 6 jours pour avoir le lundi précédent
  // Sinon, on recule de (jour-1) jours pour avoir le lundi de la semaine
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d;
}

// Fonction pour obtenir le dimanche de la semaine à partir du lundi
function getSunday(mondayDate) {
  const sunday = new Date(mondayDate);
  sunday.setDate(mondayDate.getDate() + 6);
  sunday.setHours(23, 59, 59, 999);
  return sunday;
}

// Fonction pour obtenir le lundi et le dimanche d'une semaine
function getMondayAndSunday(date) {
  const monday = getMonday(date);
  const sunday = getSunday(monday);
  return { monday, sunday };
}

// Fonction pour formater une date en français
function formatDateFR(date) {
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

// Fonction pour obtenir la semaine précédente
function getLastWeek() {
  const now = new Date();
  const lastWeekMonday = new Date(now);
  lastWeekMonday.setDate(now.getDate() - 7);
  return getMondayAndSunday(lastWeekMonday);
}

// Formater une date en YYYY-MM-DD local
function formatDateYYYYMMDD(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

module.exports = {
  parseISODate,
  getMonday,
  getSunday,
  getMondayAndSunday,
  formatDateFR,
  getLastWeek,
  formatDateYYYYMMDD
}; 